import { gql } from "@apollo/client";

export const LIST_SALE_DOCUMENT_STAGES = gql`
  query listSaleDocumentStages {
    listSaleDocumentStages {
      label
      value
    }
  }
`;

export const LIST_SALE_DOCUMENT_STATES = gql`
  query listSaleDocumentStates {
    listSaleDocumentStates {
      label
      value
    }
  }
`;

export const LIST_SALE_DOCUMENT_TYPES = gql`
  query listSaleDocumentTypes {
    listSaleDocumentTypes {
      label
      value
    }
  }
`;

export const LIST_PERIOD_CHOICES = gql`
  query listPeriodChoices {
    listPeriodChoices {
      label
      value
    }
  }
`;

export const LIST_ANALYTICAL_TYPES = gql`
  query listAnalyticalTypes {
    listAnalyticalTypes {
      label
      value
    }
  }
`;
